export default class Enrolment {
	constructor() {
		this.id = '';
		this.user = '';
		this.course = '';
		this.type = '';

		const accessLimit = new Date();
		accessLimit.setDate(accessLimit.getDate() + 30);
		this.setAccessLimit(accessLimit);
	}

	setAccessLimit(accessLimit = new Date()) {
		this.limitAccess = accessLimit.toISOString().split('T')[0];
	}
}
